import { render } from "./AddAlertPopup.vue?vue&type=template&id=9feb9cf8&scoped=true"
import script from "./AddAlertPopup.vue?vue&type=script&lang=js"
export * from "./AddAlertPopup.vue?vue&type=script&lang=js"

import "./AddAlertPopup.css?vue&type=style&index=0&id=9feb9cf8&scoped=true&lang=css"

import exportComponent from "/home/azael/Documents/GitHub/tempo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9feb9cf8"]])

export default __exports__